<template>
    <div class="board">
        <el-form :model="form" ref="form" :rules="rules" label-width="120px">
            <div class="title">
                <span class="name">{{ examEditTextConfig.advanced.title }}
                    <span class="exam_rules_title_tip">{{ examEditTextConfig.advanced.tip }}</span></span>
            </div>
            <el-row>
                <el-col :span="24">
                    <!--提前登录时间-->
                    <el-form-item :label="formTextConfig.earlyLoginDuration.label" prop="earlyLoginDuration">
                        <el-row>
                            <span>{{ formTextConfig.earlyLoginDuration.examStartPrefix }}</span>&nbsp;
                            <el-input-number v-model="form.earlyLoginDuration" :controls="false"
                                             @change="handleChange"
                                             :disabled="examStatus >=2" :step="1" step-strictly :min="1"
                                             :max="formTextConfig.earlyLoginDuration.maxHours"></el-input-number>&nbsp;&nbsp;
                            <span>{{ formTextConfig.earlyLoginDuration.examStartStuffix }}</span>
                        </el-row>
                        <el-row class="exam_rules_tip">{{ formTextConfig.earlyLoginDuration.tip }}</el-row>
                    </el-form-item>
                    <!--考生人脸识别-->
                    <el-form-item :label="formTextConfig.faceRecognition.label">
                        <el-row>
                            <el-switch v-model="form.examineeFaceCheckEnable" active-color="#13ce66"
                                       :disabled="examStatus >=2" @change="handleChange"
                                       inactive-color="#ff4949"></el-switch>
                        </el-row>
                        <el-row class="exam_rules_tip">{{ formTextConfig.faceRecognition.tip }}</el-row>
                    </el-form-item>
                    <!-- 禁止迟到作答-->
                    <el-form-item :label="formTextConfig.forbidLaterAnswer.label">
                        <el-row>
                            <el-switch v-model="form.forbidLateAnswerEnable" active-color="#13ce66" @change="handleChange"
                                       :disabled="examStatus >=2" inactive-color="#ff4949"></el-switch>
                        </el-row>
                        <template v-if="form.forbidLateAnswerEnable">
                            <el-row>
                                <span>{{ formTextConfig.forbidLaterAnswer.examStartOverPrefix }}</span>&nbsp;
                                <el-input-number v-model="form.forbidExamTimeRange" :controls="false" @change="handleChange"
                                                 :disabled="examStatus >=2" :step="1" step-strictly :min="1" :max="maxMinute"></el-input-number>&nbsp;
                                <span>{{ formTextConfig.forbidLaterAnswer.timeMinute }}</span>
                            </el-row>
                            <el-row class="exam_rules_tip">{{ formTextConfig.forbidLaterAnswer.tip }}</el-row>
                        </template>
                    </el-form-item>
                    <!-- 禁止提前交卷-->
                    <el-form-item :label="formTextConfig.forbidEarlySubmit.label">
                        <el-row>
                            <el-switch v-model="form.forbitEarlySubmitEnable" active-color="#13ce66"
                                       :disabled="examStatus >=2" @change="handleChange"
                                       inactive-color="#ff4949"></el-switch>
                        </el-row>
                        <template v-if="form.forbitEarlySubmitEnable">
                            <el-row>
                                <span>{{ formTextConfig.forbidEarlySubmit.examStart }}</span>
                                &nbsp;<el-input-number v-model="form.forbidStartRangeSubmit" :disabled="examStatus >=2" @change="handleChange"
                                                       :step="1" step-strictly :min="1" :max="maxMinute - form.forbidEndRangeSubmit"
                                                       :controls="false"></el-input-number>&nbsp;
                                <span>
                                    {{ formTextConfig.forbidEarlySubmit.examStartEnd }}{{ formTextConfig.forbidEarlySubmit.examEndBefore }}
                                </span>
                                &nbsp;<el-input-number v-model="form.forbidEndRangeSubmit" :disabled="examStatus >=2" @change="handleChange"
                                                       :step="1" step-strictly :min="1" :max="maxMinute - form.forbidStartRangeSubmit"
                                                       :controls="false"></el-input-number>&nbsp;
                                <span>{{ formTextConfig.forbidEarlySubmit.examEndBeforeEnd }}</span></el-row>
                            <el-row class="exam_rules_tip">{{ formTextConfig.forbidEarlySubmit.tip }}</el-row>
                        </template>
                    </el-form-item>
                    <!-- IP限制-->
                    <el-form-item :label="formTextConfig.ipLimit.label">
                        <el-row>
                            <el-switch v-model="form.ipLimitEnable" active-color="#13ce66" :disabled="examStatus >=2" @change="handleChange"
                                       inactive-color="#ff4949"></el-switch>
                        </el-row>
                        <template v-if="form.ipLimitEnable">
                            <el-row>{{ formTextConfig.ipLimit.ipWhiteList }}</el-row>
                            <el-input type="textarea" v-model="form.ipWhiteList" :disabled="examStatus >=2" @change="handleChange"></el-input>
                            <el-row class="exam_rules_tip">{{ formTextConfig.ipLimit.tip }}</el-row>
                        </template>
                    </el-form-item>
                    <!-- 网络限制-->
                    <el-form-item :label="formTextConfig.netLimit.label">
                        <el-row>
                            <el-switch v-model="form.netLimitEnable" active-color="#13ce66" :disabled="examStatus >=2" @change="handleChange"
                                       inactive-color="#ff4949"></el-switch>
                        </el-row>
                        <el-row class="exam_rules_tip">{{ formTextConfig.netLimit.tip }}</el-row>
                    </el-form-item>
                    <el-form-item label="">
                        <el-button type="primary" @click="submitExam" v-if="examStatus !== 3"
                                   :loading="loading">
                            {{ formTextConfig.button.ok }}
                        </el-button>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
    </div>
</template>
<script>
import {getExam, updateExamAdvanced} from "@/api/arrangement";

/**
 * 高级设置
 */
export default {
    name: 'BaseExam',
    props: ['examId', 'examStatus'],
    data() {
        return {
            loading: false,
            form: {
                //提前登录时间
                earlyLoginDuration: 24,
                //启用考生人脸识别
                examineeFaceCheckEnable: false,
                //启用禁止迟到作答
                forbidLateAnswerEnable: false,
                //迟到时长限制
                forbidExamTimeRange: 30,
                //启用禁止提前交卷
                forbitEarlySubmitEnable: false,
                //开始后时长
                forbidStartRangeSubmit: 30,
                //结束前时长
                forbidEndRangeSubmit: 15,
                //启用IP 限制
                ipLimitEnable: false,
                //IP白名单
                ipWhiteList: null,
                //启用网络限制
                netLimitEnable: false,
            },
            rules: {
                earlyLoginDuration: {required: true, message: "提前登录时间不能为空", trigger: "blur"},
            },
            // 是否有修改未提交
            change: false,
            // 考试时长-minute
            maxMinute: 30,
        }
    },
    computed: {
        examEditTextConfig() {
            return this.$store.state.global.textConfig.backend.arrangement.examEdit
        },
        formTextConfig() {
            return this.examEditTextConfig.advanced.form
        },
    },
    created() {
        if (this.examId) {
            this.getExamData(this.examId)
        }
    },
    methods: {
        // 简化校验流程，只要发生改变即视为已修改，无需校验值是否正确
        handleChange(val) {
            this.$emit("saved", false)
        },
        //获取配置信息
        getExamData(examId) {
            getExam(examId).then(res => {
                if (res.status === 200) {
                    this.form.earlyLoginDuration = res.data.earlyLoginDuration
                    this.form.examineeFaceCheckEnable = res.data.examineeFaceCheckEnable
                    this.form.forbidLateAnswerEnable = res.data.forbidLateAnswerEnable
                    this.form.forbidExamTimeRange = res.data.forbidExamTimeRange
                    this.form.forbitEarlySubmitEnable = res.data.forbitEarlySubmitEnable
                    if (res.data.forbidStartRangeSubmit) {
                        this.form.forbidStartRangeSubmit = res.data.forbidStartRangeSubmit
                    }
                    if (res.data.forbidEndRangeSubmit) {
                        this.form.forbidEndRangeSubmit = res.data.forbidEndRangeSubmit
                    }
                    this.form.ipLimitEnable = res.data.ipLimitEnable
                    this.form.ipWhiteList = res.data.ipWhiteList
                    this.form.netLimitEnable = res.data.netLimitEnable
                    this.change = false

                    //计算考试时长
                    let examDuration = res.data.examDuration
                    let examDurationUnit = res.data.examDurationUnit
                    switch (examDurationUnit) {
                        case 'minute':
                            this.maxMinute = examDuration
                            break;
                        case 'hour':
                            this.maxMinute = examDuration * 60
                            break;
                        case 'day':
                            this.maxMinute = examDuration * 60 * 24
                            break;
                    }
                }
            })
        },
        submitExam() {
            this.$refs.form.validate(vaild => {
                if (vaild) {
                    if (this.form.forbidLateAnswerEnable && !this.form.forbidExamTimeRange) {
                        this.$message.error('禁止迟到作答时间不能为空')
                        return
                    }
                    if (this.form.forbitEarlySubmitEnable && !this.form.forbidStartRangeSubmit) {
                        this.$message.error('禁止提前交卷时间不能为空')
                        return
                    }
                    if (this.form.forbitEarlySubmitEnable && !this.form.forbidEndRangeSubmit) {
                        this.$message.error('禁止提前交卷时间不能为空')
                        return
                    }
                    if (this.form.ipLimitEnable && !this.form.ipWhiteList) {
                        this.$message.error('IP白名单不能为空')
                        return
                    }
                    this.loading = true;
                    updateExamAdvanced(this.examId, this.form).then(res => {
                        if (res.status === 200) {
                            this.$message.success("编辑成功")
                            // 通知已保存
                            this.$emit("saved", true)
                        }
                        this.loading = false
                    }).catch(err => {
                        this.loading = false
                    })
                }
            })
        },
    }
}
</script>

<style scoped>
.exam_rules_title_tip {
    color: darkblue;
    font-size: 0.95em;
    margin-left: 20px;
}

.exam_rules_tip {
    color: darkgray;
}

</style>
